import { Injectable } from '@angular/core';
import { observable } from 'mobx-angular';
import { action } from 'mobx';
import { Guides } from '../mocks/guides.mock';


@Injectable()
export class GuidesStore {
    @observable guides: any[] = [];

    constructor() {
    }

    @action
    setGuides(guides) {
        this.guides = [...[], ...guides];
        console.log(this.guides);
    }
}